<template>
  <div class="apis-table">
    <v-card>
      <v-data-table
        :headers="headers"
        :items="apis ? apis : []"
        :search="search"
        :loading="fetchAllLoading"
      >
        <template v-slot:top>
          <v-toolbar flat color="white">
            <v-btn icon small color="primary" class="ma-2" @click="$emit('refresh')">
              <v-icon>refresh</v-icon>
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn color="success" @click="$emit('createNew')">
              <v-icon left>add</v-icon>Create
            </v-btn>
          </v-toolbar>
          <v-card-title>
            <v-text-field
              v-model="search"
              append-icon="search"
              label="Search"
              single-line
              hide-details
            ></v-text-field>
          </v-card-title>
        </template>
        <template v-slot:item.root_url="{ item }">
          <v-btn
            color="info"
            class="text-lowercase"
            :href="item.root_url"
            target="_blank"
            rounded
            small
            text
            dark
          >{{item.root_url}}</v-btn>
        </template>
        <template v-slot:item.actions="{ item }">
          <v-icon class="mr-2" color="primary" @click="$emit('editApi', item)" dark>mdi-pencil</v-icon>
          <v-icon color="error" @click="$emit('deleteApi', item)">mdi-delete</v-icon>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      search: "",
      headers: [
        {
          text: "ID",
          align: "start",
          filterable: true,
          value: "application_id",
          width: "20%"
        },
        {
          text: "Name",
          align: "start",
          filterable: true,
          value: "application_name",
          width: "20%"
        },
        {
          text: "Description",
          align: "start",
          filterable: true,
          value: "application_description",
          width: "20%"
        },
        {
          text: "URL",
          align: "center",
          filterable: true,
          value: "root_url",
          width: "20%"
        },
        { text: "Actions", value: "actions", sortable: false, align: "right" }
      ]
    };
  },
  computed: {
    ...mapState({
      apis: state => state.apis.all,
      fetchAllLoading: state => state.apis.fetchAll.pending,
      fetchAllError: state => state.apis.fetchAll.error
    })
  }
};
</script>

<style>
</style>